export class RequestError extends Error {
  readonly code: string
  constructor(message: string, code: string) {
    super(message)
    this.code = code
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    } else {
      this.stack = (new Error()).stack
    }
  }
}

export class NetworkError extends Error {
  constructor(...args: string[]) {
    super(...args)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    } else {
      this.stack = (new Error()).stack
    }
  }
}
